import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class RackIdRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    rackId: number;
    @ApiProperty()
    saleOrderId:number;
}